// Short celebratory chime generated with the Web Audio API (no audio asset needed).
let _ctx = null;
function ctx() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!_ctx) _ctx = new AC();
  if (_ctx.state === 'suspended') _ctx.resume().catch(() => {});
  return _ctx;
}

export function playCelebration() {
  const ac = ctx();
  if (!ac) return;
  const now = ac.currentTime;
  // A bright ascending arpeggio (C5–E5–G5–C6) with a soft master envelope.
  const notes = [523.25, 659.25, 783.99, 1046.5];
  const master = ac.createGain();
  master.gain.setValueAtTime(0.0001, now);
  master.gain.exponentialRampToValueAtTime(0.5, now + 0.05);
  master.gain.exponentialRampToValueAtTime(0.0001, now + 1.6);
  master.connect(ac.destination);
  notes.forEach((freq, i) => {
    const t = now + i * 0.12;
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(freq, t);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.4, t + 0.03);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    osc.connect(g);
    g.connect(master);
    osc.start(t);
    osc.stop(t + 0.55);
  });
}
